import { Trans } from "@lingui/react/macro";
import {
  SectionContainer,
  SectionTitle,
  SectionTitleHeading
} from "@silversea-ssc/ui-components-react";
import AsCardSlide from "components/Card/AsCardSlide";
import Slider, { SliderSlide } from "components/Slider";
import React from "react";
import { ShipFacilityFragment } from "types/graphql-types";

type Props = {
  facilities: ShipFacilityFragment[];
};

const ShipPublicAreas: React.FC<Props> = ({ facilities }) => {
  return (
    <div className="hide-print" data-content-name="section_public_areas">
      <SectionContainer
        spacingTop="regular"
        spacingBottom="regular"
        backgroundColor="white"
      >
        <SectionTitle variant="wide">
          <SectionTitleHeading>
            <Trans>Public Areas</Trans>
          </SectionTitleHeading>
        </SectionTitle>
        <Slider variantColor="neutral05">
          {facilities.map((facility) => {
            return (
              <SliderSlide key={facility._key}>
                {facility.card && <AsCardSlide card={facility.card} />}
              </SliderSlide>
            );
          })}
        </Slider>
      </SectionContainer>
    </div>
  );
};

export default ShipPublicAreas;
